import { cn } from "../lib/cn";

export type ProgrammeStatus = "participating" | "preparing" | "participated" | "blocked";

const DOT: Record<ProgrammeStatus, string> = {
	participating: "bg-brand-hover",
	preparing: "bg-programme",
	participated: "bg-fg-muted",
	blocked: "bg-notify",
};

export interface ProgrammeStatusDotProps {
	status?: ProgrammeStatus;
	/** Сторона квадрата-обёртки. Точка внутри всегда 6/16 от него (DS, figma 1:19). */
	box?: number;
	className?: string;
	label?: string;
}

/**
 * Точка статуса программы. Живёт в квадрате, а не сама по себе: так она
 * оптически выравнивается по строке текста независимо от размера подписи.
 */
export function ProgrammeStatusDot({
	status = "participating",
	box = 16,
	className,
	label,
}: ProgrammeStatusDotProps) {
	const dot = Math.round((box * 6) / 16);
	const glyph = (
		<span
			className={cn("absolute rounded-full", DOT[status])}
			style={{ width: dot, height: dot, left: (box - dot) / 2, top: (box - dot) / 2 }}
		/>
	);
	const style = { width: box, height: box };

	// Две ветки, а не один span с условными атрибутами: точка без подписи —
	// декорация и должна быть невидима скринридеру, с подписью — картинка со смыслом.
	if (label) {
		return (
			<span
				role="img"
				aria-label={label}
				className={cn("relative inline-block shrink-0", className)}
				style={style}
			>
				{glyph}
			</span>
		);
	}
	return (
		<span
			aria-hidden="true"
			className={cn("relative inline-block shrink-0", className)}
			style={style}
		>
			{glyph}
		</span>
	);
}
